module.exports = __webpack_public_path__ + "141d4a85/img/arrow-export-icon.a3345173.svg";